import { useAuth0 } from '@auth0/auth0-react'
import { useAtomValue, useSetAtom } from 'jotai'
import { useResetAtom } from 'jotai/react/utils'
import { Path, useLocation } from 'react-router-dom'
import { useUserMetadata } from '~/api/api.hook'
import { useAuthenticatedUser } from '~/auth/user.hooks'
import { contextState, currentScopeState, loadingState } from '~/state'
import { scopedHref, shortScopeId } from '~/utils/scope-path'

export const reloadOnScope = (shortId: string, path: Path) => window.location.replace(scopedHref(shortId, path))

export const useSwitchScope = (onDone?: () => void) => {
  const { byId: userMetaDataById } = useUserMetadata(null)
  const user = useAuthenticatedUser()
  const currentScope = useAtomValue(currentScopeState)
  const { getAccessTokenSilently } = useAuth0()
  const resetContext = useResetAtom(contextState)
  const setLoading = useSetAtom(loadingState)
  const location = useLocation()

  return async (scopeId: string) => {
    await userMetaDataById.put({
      scopeId,
      alertEmail: user.alertEmail ?? { [currentScope.id]: false },
    })
    const loading = getAccessTokenSilently({ cacheMode: 'off' })
    setLoading(true)
    onDone?.()
    await loading
    resetContext()
    reloadOnScope(shortScopeId(scopeId), location)
  }
}
